import * as React from 'react';

export type ElementListProps = {
	children?: React.ReactNode;
};

export default class ElementList extends React.Component<ElementListProps> {
	public render() {
		return <ul className="m-element-list">{this.props.children}</ul>;
	}
}
